/* eslint-disable no-plusplus */
import React from 'react';

export default function CronTimeDropDown() {
  const hours = [];
  for (let i = 1; i <= 24; i++) {
    hours.push(i);
  }
  return (
    hours.map((hour) => <option value={hour}>{hour}</option>)
  );
}
